const sortLeavingSpecialCharactersAtTheEnd = array => {
  const namesStartingWithLetter = []
  const namesStartingWithSpecialCharacter = []

  array.forEach(name =>
    name.charAt(0).match(/[a-z]/i) ? namesStartingWithLetter.push(name) : namesStartingWithSpecialCharacter.push(name)
  )

  return namesStartingWithLetter.sort().concat(namesStartingWithSpecialCharacter.sort())
}

export const getListingFacetNames = (thisListing, facetCategory) => thisListing[facetCategory].map(facet => facet.name)

export const getListingsFacetNames = (listings, facetCategory) => {
  const facetNames = []

  listings.forEach(listing => {
    listing[facetCategory].forEach(feature => facetNames.push(feature.name))
  })

  return sortLeavingSpecialCharactersAtTheEnd([...new Set(facetNames)])
}

export const mostFacets = (listings, thisListing, facetCategory) => {
  const maxFacets = Math.max(...listings.map(listing => listing[facetCategory].length))
  return getListingFacetNames(thisListing, facetCategory).length === maxFacets
}

export const getPricingUrl = thisListing => {
  const hasPricingSpotlight = thisListing.is_premium && !!thisListing.cta_urls.spotlight_pricing
  return hasPricingSpotlight ? thisListing.cta_urls.spotlight_pricing : thisListing.cta_urls.pricing
}
